import React from 'react';
import PropTypes from 'prop-types';

const Dialogue = (props) => {
  const {
    title,
    subtitle,
    subtitle2,
    logoClass,
    data,
    dialogueButtons,
  } = props;
  return (
    <>
      <div className={logoClass} />
      <h1 className="title">{title}</h1>
      <p className="subtitle">
        {subtitle}
        <br />
        {subtitle2}
        <br />
        <b>{data}</b>
      </p>
      {dialogueButtons && (
        <div className="btnwrapper">
          {dialogueButtons.map((item, index) => (
            <button
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              type="button"
              className={item.cssClass}
              onClick={item.handleClick}
              onKeyPress={item.handleClick}
              tabIndex="0"
            >
              {item.text}
            </button>
          ))}
        </div>
      )}
    </>
  );
};

Dialogue.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  subtitle2: PropTypes.string,
  logoClass: PropTypes.string,
  data: PropTypes.string,
  dialogueButtons: PropTypes.shape({
    cssClass: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
  }).isRequired,
};

Dialogue.defaultProps = {
  subtitle: '',
  subtitle2: '',
  logoClass: '',
  data: '',
};

export default Dialogue;
